import React from "react";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";

import Select from "react-select";
import moment from "moment";
import {
  UserProfileType,
  PersonalDetails as PersonalDetailsType,
} from "../../../redux/auth/authTypes";
import {
  BLOOD_GROUP,
  GENDER_STATUS,
  MARTIAL_STATUS,
} from "../../../constant/userProfileConstant";
import { CalenderIcon } from "../../Icon";
import { handleDate } from "../../../utils/commonFunctions";

type AppProps = {
  data: PersonalDetailsType;
  isEdit?: boolean | string;
  setProfileForm: React.Dispatch<React.SetStateAction<UserProfileType>>;

  handlePersonalDetails: (data: any) => void;
};
const LoggedInUserPersonalDetails = ({
  data,
  isEdit,
  handlePersonalDetails,
  setProfileForm,
}: AppProps) => {
  const handleDateChange = (e: any) => {
    let dateOfBirth = handleDate(e);
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          personal_details: {
            ...prv?.user_details?.personal_details,
            date_of_birth: dateOfBirth,
          },
        },
      };
    });
  };
  return (
    <div className="form-group">
      <h6>PERSONAL DETAILS</h6>

      <div className="row mt-2">
        <div className="col-md-3">
          <label htmlFor="dateOfBirth">Date of Birth</label>
          <div className="d-flex flex-row position-relative">
            <div className="date-picker-wraper mr-0 w-100">
              <Label className="mr-0 w-100">
                <DatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    data?.date_of_birth
                      ? new Date(
                        moment(
                          `${data?.date_of_birth}T00:00:00`,
                          "YYYY-MM-DD"
                        ).format("YYYY-MM-DD[T]HH:mm:ss")
                      )
                      : null
                  }
                  onChange={(e: any) => {
                    handleDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="date_of_birth"
                  placeholderText="Select"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{ right: "20px", top: "10px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <label htmlFor="gender">Gender </label>

          <Select<any, false>
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select Gender"}
            options={GENDER_STATUS}
            value={
              data &&
              data?.gender && {
                label: data?.gender,
                value: data?.gender,
              }
            }
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv?.user_details,
                      personal_details: {
                        ...prv?.user_details?.personal_details,
                        // ...prv,user_details.personal_details,
                        gender: e?.value,
                      },
                    },
                  };
                });
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-3">
          <label htmlFor="bloodGroup">Blood Group </label>

          <Select<any, false>
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select Blood Group"}
            options={BLOOD_GROUP}
            value={
              data &&
              data?.blood_group && {
                label: data?.blood_group,
                value: data?.blood_group,
              }
            }
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv?.user_details,
                      personal_details: {
                        ...prv?.user_details?.personal_details,
                        // ...prv,user_details.personal_details,
                        blood_group: e?.value,
                      },
                    },
                  };
                });
              }
            }}
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="aboutMe">Qualifications</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="qualifications"
              onChange={handlePersonalDetails}
              value={data?.qualifications || ""}
            />
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-3">
          <label htmlFor="aboutMe">Mother’s Name</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="mother_name"
              onChange={handlePersonalDetails}
              value={data?.mother_name || ""}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="aboutMe">Marital Status</label>
          <Select<any, false>
            inputProps={{ autoComplete: "nope" }}
            placeholder={"Select Status"}
            options={MARTIAL_STATUS}
            value={
              data &&
              data?.martial_status && {
                label: data?.martial_status,
                value: data?.martial_status,
              }
            }
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv?.user_details,
                      personal_details: {
                        ...prv?.user_details?.personal_details,
                        martial_status: e?.value,
                      },
                    },
                  };
                });
              }
            }}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="aboutMe">Spouse Name</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="spouse_name"
              onChange={handlePersonalDetails}
              value={data?.spouse_name || ""}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="aboutMe">Father/Husband Name</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="father_or_husband_name"
              onChange={handlePersonalDetails}
              value={data?.father_or_husband_name || ""}
            />
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-6">
          <label htmlFor="aboutMe">About Me</label>
          <div className="d-flex flex-row position-relative">
            <textarea
              className="form-control"
              name="about_me"
              style={{ height: "115px", resize: "none" }}
              onChange={handlePersonalDetails}
              value={data?.about_me || ""}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoggedInUserPersonalDetails;
